export const getRandomPosition = () => {
  // Get window dimensions
  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  // Calculate bottom Y position between 70% and 90% of screen height
  const minY = windowHeight * 0.7;
  const maxY = windowHeight * 0.22;
  const y = Math.floor(Math.random() * (maxY - minY) + minY);

  // Calculate X position between 20% and 80% of screen width
  const randomRange = Math.random();
  let x;
  if (randomRange < 0.5) {
    // 0-40% of screen width
    const minX = windowWidth * 0.05;
    const maxX = windowWidth * 0.3;
    x = Math.floor(Math.random() * (maxX - minX) + minX);
  } else {
    // 60-100% of screen width
    const minX = windowWidth * 0.55;
    const maxX = windowWidth * 0.75;
    x = Math.floor(Math.random() * (maxX - minX) + minX);
  }

  return { x, y };
};

export const getRandomMessage = (type, correctTime, userTime, points) => {
  const goodMessages = [
    "Correct!",
    "Great job!",
    "Bang!",
    "That's it!",
    "You should be incarcerated!!!!",
    "Well done!",
    "So good!",
    "You're a genius!",
    "¡Correctamundo!",
    "¡Eres un loco!",
  ];
  const badMessages = [
    `Nope! The correct time was ${correctTime} and you said: ${userTime}`,
    `Try again! It was ${correctTime}`,
    `Wrong! The time was ${correctTime}`,
  ];

  const goodPointMessages = [
    `El Fuego! +${points} points!`,
    `${points} BIG BOOMS!!`,
    `You got it! +${points} points!`,
    `Anotha one. +${points} points champ!`,
    `+${points} on the board!!`,
    `You earned another +${points}. Don't stop! `,
    `+${points} ¡Estás en fuego!`,
  ];

  const badPointMessages = [
    `Whoopsie! -${points} points!`,
    `Nope! -${points} points!`,
    `Wrong! -${points} points!`,
    `You lose -${points} points!`,
    `Nope! -${points} points!`,
  ];

  if (type === "Good") {
    return goodMessages[Math.floor(Math.random() * goodMessages.length)];
  }
  if (type === "GoodPoints") {
    return goodPointMessages[
      Math.floor(Math.random() * goodPointMessages.length)
    ];
  }
  if (type == "PoorPoints") {
    return badPointMessages[
      Math.floor(Math.random() * badPointMessages.length)
    ];
  }
  if (type === "Poor") {
    return badMessages[Math.floor(Math.random() * badMessages.length)];
  }
};
